import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

/**
 * Checks if the user is logged in.
 * @author Brayan Cataño
 * @description Checks for the presence of JWT token in sessionStorage, if there is means that the user is logged in. If not present means the user needs to login.
 * @returns {boolean} Returns boolean meaning the presence of jWT token in session storage
 */
export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const gaurdActive = sessionStorage.getItem('authenticated') === 'true' || !!sessionStorage.getItem('token');

  if(gaurdActive){
    return true;
  }else{
    router.navigate(['login']);
    return false;
  }
};
